'use client';

import type React from 'react';
import type { AppDetail } from '../utils/home.types';
import AppCard from './AppCard';

interface AppListProps {
  list: Array<AppDetail>;
}

const AppList: React.FC<AppListProps> = ({ list }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {list.map(app => (
        <AppCard key={app.id} app={app} />
      ))}
    </div>
  );
};

export default AppList;
